module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-landscaping.svg?19cc5113115bc3687e725590e95d24e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-landscaping.svg
// module id = 1034
// module chunks = 1